<template>
  <div class="lineDetail">
    <div class="baseinfo boxs">
      <div class="info-header">
        <div class="info-header-left">
          <div class="name">{{detail.startStationName}}</div>
          <div>-</div>
          <div class="name">{{ detail.endStationName }}</div>
        </div>
        
        <el-button v-if="btnPreFn('scheduling_edit', false)" type="primary" @click="editClick">编辑线路信息</el-button>

      </div>
      <el-descriptions :column="1" size="medium" border>
        <el-descriptions-item label="出发地">{{detail.startStationName}}</el-descriptions-item>
        <el-descriptions-item label="出发城市">{{ detail.startProvincialCity || '-' }}</el-descriptions-item>
        <el-descriptions-item label="目的地">{{ detail.endStationName }}</el-descriptions-item>
        <el-descriptions-item label="目的城市">{{ detail.endProvincialCity || '-' }}</el-descriptions-item>
        <el-descriptions-item label="机构名称">{{organizationName || '-'}}
        </el-descriptions-item>
        <el-descriptions-item label="线路标签">
          <el-tag type="info">{{ detail.labelName || '-' }}</el-tag>
        </el-descriptions-item>
      </el-descriptions>
        <el-descriptions :column="1" size="medium" border>
        <el-descriptions-item label="购票限制">
          {{ detail.ticketRestrictions == 1 ? '非实名' : '实名' }}
          <el-button type="text" size="medium">
            <i class="el-icon-edit"  @click="editTicketRestrictions" v-if="btnPreFn('ticket_restrictions', false)"></i>
          </el-button>
        </el-descriptions-item>
        <el-descriptions-item label="司机提成">
          {{ detail.commissionConfigName ? detail.commissionConfigName : '未启用' }}
          <el-button type="text" size="medium" @click="editDriverCommission" v-if="btnPreFn('scheduling_edit', false)">
            <i class="el-icon-edit"></i>
          </el-button>
        </el-descriptions-item>
        <el-descriptions-item label="发车限制">
          {{ detail.departureRestrictionsConfig ? `可提前${detail.departureRestrictionsConfig}分钟发车` : '未启用' }}
          <el-button type="text" size="medium" @click="editDepartConfig" v-if="btnPreFn('scheduling_edit', false)">
            <i class="el-icon-edit"></i>
          </el-button>
        </el-descriptions-item>
        <el-descriptions-item label="线路报班">
          {{ detail.driverRegister == 1 ? '已启用' : '未启用' }}
          <el-button type="text" size="medium">
            <i class="el-icon-edit" @click="editDriverRegister" v-if="btnPreFn('line_driver_register', false)"></i>
          </el-button>
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <el-tabs v-model="activeName" class="driver-tabs boxs">
      <el-tab-pane label="线路信息" name="lineInfo">
        <lineInfo v-if="activeName === 'lineInfo'"></lineInfo>
      </el-tab-pane>
      <el-tab-pane label="线路票价" name="linePrice">
        <linePrice v-if="activeName === 'linePrice'"></linePrice>
      </el-tab-pane>
      <el-tab-pane label="渠道票价" name="channelPrice">
        <channelPrice v-if="activeName === 'channelPrice'" :lineId="id"
          :channelTcServiceFee="detail.channelTcServiceFee"></channelPrice>
      </el-tab-pane>
    </el-tabs>

    <!--购票限制弹框-->
    <ticket-restrictions-dialog
      :visible.sync="ticketRestrictionsConfigVisible"
      :row-data="ticketRestrictionsConfigRow"
      @success="configClose"
    />

    <el-dialog title="司机提成" :visible.sync="driverCommissionVisible" width="630px">
      <driver-commission-dialog v-if="driverCommissionVisible" :config="driverCommission" @success="configClose"></driver-commission-dialog>
    </el-dialog>

    <el-dialog title="发车限制" :visible.sync="departConfigVisible" width="630px">
      <depart-config-dialog v-if="departConfigVisible" :config="departConfig" @success="configClose"></depart-config-dialog>
    </el-dialog>

  </div>
</template>

<script>
import lineInfo from './lineInfo.vue';
import linePrice from './linePrice.vue';
import channelPrice from './channelPrice.vue';
import DriverCommissionDialog from '../components/DriverCommissionDialog.vue';
import TicketRestrictionsDialog from '../components/TicketRestrictionsDialog';
import DepartConfigDialog from '../components/DepartConfigDialog.vue';
export default {
  name: "lineDetail",
  components: {
    lineInfo,
    linePrice,
    channelPrice,
    DriverCommissionDialog,
    TicketRestrictionsDialog,
    DepartConfigDialog
  },
  data() {
    return {
      id: this.$route.query.id,
      organizationName: '',
      detail: {},
      activeName: 'lineInfo',
      ticketRestrictionsConfigVisible: false,
      ticketRestrictionsConfigRow: {},
      
      driverCommissionVisible: false,
      departConfigVisible: false,
    };
  },
  computed: {
    departConfig() {
      return {
        lineId: this.detail.id,
        departureRestrictions: this.detail.departureRestrictions,
        departureRestrictionsConfig: this.detail.departureRestrictionsConfig
      }
    },
    driverCommission() {
      return {
        lineId: this.detail.id,
        commissionConfig: this.detail.commissionConfig,
        commissionConfigId: this.detail.commissionConfigId,
        organizationId: this.detail.organizationId
      }
    }
  },
  watch: {},
  async created() {
    this.getInfo();
  },
  methods: {
    editTicketRestrictions() {
      this.ticketRestrictionsConfigVisible = true;
      this.ticketRestrictionsConfigRow = this.detail;
    },
    configClose() {
      this.ticketRestrictionsConfigVisible = false;
      this.driverCommissionVisible = false;
      this.departConfigVisible = false;
      this.getInfo();
    },
    editDriverCommission() {
      this.driverCommissionVisible = true;
    },
    editDepartConfig() {
      this.departConfigVisible = true;
    },
    editDriverRegister(){
      this.$router.push({
        path: '/customizeReporting',
        query: {
          lineId: this.detail.id,
          driverRegister: this.detail.driverRegister
        }
      })
    },
    async editClick() {
      let url = "/api/v1/manage/line/isUpdate/" + this.id;
      let { code, data } = await this.$axios.get(url);
      if (code == 1 && data) {
        this.$router.replace({ path: "/dockingPoint", query: { id: this.id } });
      }
    },

    /* 获取线路详情 */
    async getInfo() {
      if (!this.id) {
        return false;
      }
      let url = "/api/v1/manage/line/" + this.id;
      let { code, data } = await this.$axios.get(url);
      if (code === 1 && data?.stationVoList) {
        this.detail = data;
        this.organizationName = await this.getOrgName(data.organizationId)
      }
    },
  },
};
</script>

<style lang="less" scoped>
.lineDetail {
    display: flex;
    gap: 20px;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: var(--bg-color);

    .boxs {
        height: calc(100vh - 160px);
        background: #fff;
        padding: 16px;
        border-radius: 10px;
        overflow-y: auto;
    }

    .baseinfo {
        width: 370px;
        flex-shrink: 0;

        .info-header {
          width: 100%;
            height: 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            &-left {
                display: flex;
                align-items: center;
                font-size: 16px;
                font-weight: 500;
                gap: 6px;

                .name{
                  max-width: 120px;
                  font-size: 16px;
                  font-weight: bold;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
            }
        }

        :deep(.el-descriptions) {
            border-radius: 8px;
            position: relative;
            overflow: hidden;
            margin-top: 16px;
        }

        :deep(.el-descriptions)::after {
            content: '';
            pointer-events: none;
            position: absolute;
            inset: 0;
            border-radius: 8px;
            border: 1px solid #EBEEF5;
            z-index: 1;
        }

        :deep(.el-descriptions-row) {
        display: flex;
    }

    :deep(.el-descriptions-item__cell) {
        border-top: 0;
        border-left: 0;
    }

    :deep(.el-descriptions-item__label.is-bordered-label) {
        width: 110px;
        flex-shrink: 0;
        background-color: #FBFBFB;
    }

    :deep(.el-descriptions-item__content) {
        flex: 1;
    }
    }

    .driver-tabs {
        flex: 1;
    }

    /deep/ .el-tabs__content {
        height: calc(100vh - 214px);
        overflow-y: auto;
        padding-right: 20px;

        &::-webkit-scrollbar {
            width: 5px;
        }

        &>div {
            width: 100%;
            height: 100%;
        }
    }
    /deep/ .el-tabs__nav-wrap::after {
        height: 1px;
    }
}
</style>